<div *ngIf="isRequesting" class="input-group">
  <label>Please wait..</label>

  </div>
  <div *ngIf="!isRequesting" class="input-group">

    <select class="form-control padding-top-0px padding-bottom-0px" name="value" [(ngModel)]="value"
            [style.fontSize.px]="FontSize"
            [style.height.rem]="Height"
            (change)="onChange($event.target.value)">

    <option *ngFor="let R of CurrentCustomCodeValuesController" [value]="R.Code != null ? R.Code : R.code"
            [selected]="(R.Code != null ? R.Code : R.code) === SelectedValue">
      {{R.DisplayName || R.displayName || R.SearchName || R.searchName}}
    </option>
   
  </select>
    
</div>
